import React, { Component } from "react";
import "./AccountingDataPane.scss";
import { useEffect, useState } from "react";
import StatusChip from "../StatusChip/StatusChip";
import {dateFormatter} from "Utils/dateUtils";

const AccountingDataPane = ({ accountingDetailsNew }) => {
  const [dataByStageId, setDataByStageId] = useState([]);

  useEffect(() => {
    let stageData = Object.keys(accountingDetailsNew)
      .reverse()
      .map(function (key) {
        return {
          stageId: key,
          caseStageName: accountingDetailsNew[key][0].disputeStageName,
          financialGroup: groupFinancialsByFields(accountingDetailsNew[key], function (item) {
            let filterElements = [item.status, item.adjustmentDate, item.user, item.resolvedTo];
            if (!!item.takeActionCode && item.takeActionCode.length > 0)
            {
              filterElements.push(item.takeActionCode);
            }
            return filterElements;
          }),
        };
      });
    setDataByStageId(stageData);
  }, [accountingDetailsNew]);

  const groupFinancialsByFields = (financialData, f) => {
    var groups = {};
    financialData.forEach(function (o) {
      var group = JSON.stringify(f(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(function (group) {
      return groups[group];
    });
  };

  const stageData = (data) => { 
    return (
      <div className="container">
        <div className="container__flexRow">
          <div className="container__divStageId">
            <div className="container__stagesInfo">Stage ID</div>
            <div className="container__stagesData">{data.stageId}</div>
          </div>
          <div className="container__divFixed">
            <div className="container__stagesInfo">Case Stage</div>
            <div className="container__stagesData">{data.caseStageName}</div>
          </div>
        </div>
        <div>
          <div className="stageTable">
            <div className="stageTable__header">
              <div className="stageTable__col">GL</div>
              <div className="stageTable__col">Description</div>
              <div className="stageTable__col stageTable__dbcrHead">Debit Amount</div>
              <div className="stageTable__col stageTable__dbcrHead">Credit Amount</div>
              <div className="stageTable__col">Adjustment Date</div>
              <div className="stageTable__col stageTable__status">Status</div>
              <div className="stageTable__col stageTable__user">User</div>
              <div className="stageTable__col stageTable__user">Resolved To</div>
            </div>
            <div className="table">
              {data.financialGroup.map((item, i) => {
                const displayStatusInfo = item.length % 2 === 0 ? item.length / 2 : (item.length + 1) / 2;
                return (
                  <div className="stageTable__pendingVoid row ">
                    {item.map((ele, index) => {
                      return (
                        <div
                          className={
                            'stageTable__content--row ' +
                            (index === item.length - 1 && i !== data.financialGroup.length - 1
                              ? 'stageTable--border'
                              : 'stageTable--border-none')
                          }
                        >
                          <div className="stageTable__col">
                            <span>{ele.accountNumber}</span>
                            {ele.adjustment === 'CREDIT' ? (
                              <span className="stageTable__cr-dr"> CR</span>
                            ) : (
                              <span className="stageTable__cr-dr"> DR</span>
                            )}
                          </div>
                          <div className="stageTable__col">
                            {ele.accountDescription.includes('Ledger')
                              ? ele.accountDescription.replace('Ledger', '')
                              : ele.accountDescription}
                          </div>
                          <div className="stageTable__col stageTable__creddeb stageTable__data">
                            {ele.adjustment === 'CREDIT' ? (
                              ''
                            ) : (
                              <span className="stageTable__data--textDebit">
                                {ele.amount} <span className="stageTable__curencyCode">{ele.numericCurrencyCode}</span>{' '}
                              </span>
                            )}
                          </div>
                          <div className="stageTable__col stageTable__creddeb stageTable__data">
                            {ele.adjustment === 'CREDIT' ? (
                              <span className="stageTable__data--textCredit">
                                {ele.amount} <span className="stageTable__curencyCode">{ele.numericCurrencyCode}</span>{' '}
                              </span>
                            ) : (
                              ''
                            )}
                          </div>
                          {displayStatusInfo === index ? (
                            <div className="stageTable__col stageTable__alignCenter stageTable__date">
                              {dateFormatter(ele.adjustmentDate)}
                            </div>
                          ) : (
                            <div className="stageTable__col stageTable__alignCenter stageTable__date"></div>
                          )}
                          {displayStatusInfo === index ? (
                            <div className="stageTable__col stageTable__alignCenter">
                              {<StatusChip status={ele.status} />}
                            </div>
                          ) : (
                            <div className="stageTable__col stageTable__alignCenter"></div>
                          )}
                          {displayStatusInfo === index ? (
                            <div className="stageTable__col stageTable__alignCenter stageTable__date">{ele.user}</div>
                          ) : (
                            <div className="stageTable__col stageTable__alignCenter stageTable__date"></div>
                          )}
                          {displayStatusInfo === index ? (
                            <div className="stageTable__col stageTable__alignCenter stageTable__date">
                              {ele.resolvedTo}
                            </div>
                          ) : (
                            <div className="stageTable__col stageTable__alignCenter stageTable__date"></div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
};

  return (
    <>
      <h3 className="ledgers">Ledgers</h3>   
      {dataByStageId.length > 0
        ? dataByStageId.map((data) => (
            stageData(data)
          ))
        : <div className="no-content"> -- </div>}
    </>
  );


  
};

export default AccountingDataPane;
